import { render, staticRenderFns } from "./SimpleNumKeyboard.vue?vue&type=template&id=ce2d1aa6&scoped=true"
import script from "./SimpleNumKeyboard.vue?vue&type=script&lang=js"
export * from "./SimpleNumKeyboard.vue?vue&type=script&lang=js"
import style0 from "./SimpleNumKeyboard.vue?vue&type=style&index=0&id=ce2d1aa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2d1aa6",
  null
  
)

export default component.exports